module.exports = __webpack_public_path__ + "img/people-shadow.3f827ce1.svg";